/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {CouponAddDto} from '../models/CouponAddDto'
import type {CouponCollectionDtoIDataResult} from '../models/CouponCollectionDtoIDataResult'
import type {CouponDetailDtoListSuccessDataResult} from '../models/CouponDetailDtoListSuccessDataResult'
import type {CouponDetailDtoSuccessDataResult} from '../models/CouponDetailDtoSuccessDataResult'
import type {CouponWithMerchantDtoListIDataResult} from '../models/CouponWithMerchantDtoListIDataResult'
import type {CancelablePromise} from '../core/CancelablePromise'
import {CouponWithMerchantDto, OpenAPICouponCenter} from 'rest'
import {request as __request} from '../core/request'
import {formatDateToUTC, formatDateToYMD} from 'utils/dates.utils'
import {transformCoupon} from './CouponQueueService'
import {PaginatedResult} from 'rest/types/PaginatedResult'

const mapCouponById = (response: PaginatedResult<any>) => {
  const result = response.results[0]
  if (result) {
    return {...transformCoupon(result), ...result}
  }

  return null
}

export class CouponService {
  /**
   * @returns CouponWithMerchantDtoListIDataResult Success
   * @throws ApiError
   */
  public static getApiCouponFeatured(): CancelablePromise<CouponWithMerchantDtoListIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Coupon/Featured',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param id
   * @returns CouponWithMerchantDtoIDataResult Success
   * @throws ApiError
   */
  public static getApiCouponId(
    id: number
  ): CancelablePromise<CouponWithMerchantDto> {
    const storeClient = JSON.parse(localStorage.getItem('user'))?.store?.client
    // const storeId = JSON.parse(localStorage.getItem('user'))?.store?.id
    return __request(OpenAPICouponCenter, {
      transformResponse: mapCouponById,
      method: 'GET',
      url: '/api/v1/coupons/',
      query: {
        id_search_text: id,
        client: storeClient,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param storeId
   * @returns CouponCollectionDtoIDataResult Success
   * @throws ApiError
   */
  public static getApiCouponStore(
    storeId: number
  ): CancelablePromise<CouponCollectionDtoIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Coupon/store/{storeId}',
      path: {
        storeId: storeId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param categoryId
   * @returns CouponCollectionDtoIDataResult Success
   * @throws ApiError
   */
  public static getApiCouponCategory(
    categoryId: number
  ): CancelablePromise<CouponCollectionDtoIDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Coupon/category/{categoryId}',
      path: {
        categoryId: categoryId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param requestBody
   * @returns CouponDetailDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static postApiCouponAdd(
    requestBody?: CouponAddDto
  ): CancelablePromise<CouponDetailDtoSuccessDataResult> {
    const storeId = JSON.parse(localStorage.getItem('user'))?.store?.id
    console.log('requestBody', requestBody)
    return __request(OpenAPICouponCenter, {
      method: 'POST',
      url: '/api/v1/coupons/',
      body: {
        ...requestBody,
        offer_type: requestBody.typeId,
        approved: true,
        custom_url: requestBody.destinationUrl,
        description: requestBody.description,
        destination_affiliate_url: requestBody.destinationUrl,
        destination_coupon_url: requestBody.destinationUrl,
        discount_code: requestBody.code,
        expiration_date: requestBody.expired
          ? formatDateToYMD(requestBody.expired)
          : null,
        savings_amount: requestBody.savings,
        savings_minimum_order: requestBody.minimum,
        savings_percent: requestBody.savings,
        start_date: requestBody.started
          ? formatDateToYMD(requestBody.started)
          : null,
        store: storeId,
        title: requestBody.headline,
        up_to_savings_percent: 0,
      },
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param couponId
   * @returns CouponDetailDtoSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiCouponGet(
    couponId?: number
  ): CancelablePromise<CouponDetailDtoSuccessDataResult> {
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/Coupon/Get',
      query: {
        couponId: couponId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }

  /**
   * @param merchantId
   * @returns CouponDetailDtoListSuccessDataResult Success
   * @throws ApiError
   */
  public static getApiCouponGetByMerchant(): CancelablePromise<CouponDetailDtoListSuccessDataResult> {
    const slug = JSON.parse(localStorage.getItem('user'))?.store?.slug
    return __request(OpenAPICouponCenter, {
      method: 'GET',
      url: '/api/coupons/',
      transformResponse: data => {
        return data
      },
      query: {
        store_slug: slug,
        include_scheduled: '1',
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    })
  }
}
